import { render, staticRenderFns } from "./AddFieldLaborRevenueRates.vue?vue&type=template&id=296a0f24&scoped=true"
import script from "./AddFieldLaborRevenueRates.vue?vue&type=script&lang=js"
export * from "./AddFieldLaborRevenueRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a0f24",
  null
  
)

export default component.exports